import { Helmet } from 'react-helmet-async';
// sections
import TraCuuLoSamView from 'src/sections/losam/view/tracuu-losam-view';

// ----------------------------------------------------------------------

export default function TraCuuLoSamPage() {
  return (
    <>
      <Helmet>
        <title> Quản trị: Tra cứu lô sâm</title>
      </Helmet>

      <TraCuuLoSamView />
    </>
  );
}
